export default function getPath(
    environment = 'staging', // 'staging' or 'prod'
    hosts = {
        prod: 'www.autotrader.com',
        staging: 'test.autotrader.com',
    }
) {
    // default to 'staging' when invalid environment value is passed
    const path = hosts[environment] || hosts.staging || '';

    return `https://${path}/`;
}
